import { useLang } from '@/app/utils/useLang';
import CommonProducts from '../components/common-products';

const EnergyStorage: React.FC = () => {
    const { t } = useLang('landingPage.energy_storage');
    const items = [
        {
            img: '',
            label: t('item1_title'),
            productId: '8012436209818',
            variantId: '44960085639322',
            learnMore: 'https://ca.ecoflow.com/products/delta-pro-ultra-battery?_pos=2&_sid=4a62213dd&_ss=r&variant=62283291951475',
        },
        {
            img: '',
            label: t('item2_title'),
            productId: '8231518666906',
            variantId: '44902577209498',
            learnMore: 'https://ca.ecoflow.com/products/delta-pro-3-extra-battery?variant=44902577209498',
        },
        {
            img: '',
            label: t('item3_title'),
            productId: '7285229682842',
            variantId: '43725966016666',
            learnMore: 'https://ca.ecoflow.com/products/delta-pro-smart-extra-battery?variant=43725966016666',
        },
    ];

    return (
        <div>
            <CommonProducts items={items} title={t('title')} />
        </div>
    );
};

export default EnergyStorage;
